<div
  #wrapper
  class="iu-input-icon-ui"
  [pTooltip]="tooltip"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  [style.width]="overridedCSS?.width"
  [tooltipOptions]="TOOLTIP_OPTIONS">
  @if (isLabelDisplay && !!label?.trim()) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label"
      >{{ label }}</label
    >
  }

  <span
    [attr.data-enabled]="true"
    [attr.data-focus]="open()"
    [attr.data-readonly]="isReadOnly"
    [ngClass]="[hasConflict ? 'iu-field-conflict-text' : '', mandatoryCss, 'ui-corner-all input-field p-inputtext']"
    (click)="onClick($event, input)"
    (contextmenu)="onContextMenu($event)"
    (press)="onContextMenu($any($event))">
    @if (value()) {
      <i aria-hidden="true" [ngClass]="value()?.id"></i>
    }

    <input
      #input
      autocomplete="off"
      data-cy="input-icon"
      [attr.data-cy-columnName]="data ? data.columnName : columnName"
      [id]="uuid"
      [placeholder]="placeHolder ?? ''"
      [readonly]="isReadOnly"
      [style.font-size]="overridedCSS?.inputFontSize"
      [style.height]="overridedCSS?.inputHeight"
      [tabindex]="isReadOnly ? '-1' : null"
      [type]="data ? data.fieldType : 'text'"
      [(ngModel)]="rawValue"
      (focus)="toggle(true)"
      (input)="onUserInput($any($event))"
      (keydown)="onKeyDown($event)"
      (keyup)="onKeyUp($event)"
      (mousedown)="$event.preventDefault()" />

    <iu-dropdown class="input-icon-dropdown" [linkedTo]="[wrapper]" [(open)]="open">
      <div class="input-icon-dropdown-content">
        <div
          #categoriesEl
          class="input-icon-categories"
          highlighted
          id="categories"
          [attr.data-highlighted]="highlightIndex() === -1"
          (mouseenter)="resetHighlight()">
          <ng-container
            *ngTemplateOutlet="categoryItem; context: { category: 'inputIcon.allCategory' | translate, isAll: true }" />

          @for (category of categories(); track category; let index = $index) {
            <ng-container *ngTemplateOutlet="categoryItem; context: { category, isAll: false }" />
          }
        </div>

        <div #fake class="input-icon-list-item input-icon-list-item-fake" [attr.data-height]="iconItemSize()">
          <i aria-hidden="true" class="fa-solid fa-smile"></i>
          <span class="value">
            <span class="label">Fake label</span>
            <span class="id">Fake id</span>
          </span>
        </div>

        <cdk-virtual-scroll-viewport
          class="input-icon-list"
          [itemSize]="iconItemSize()"
          [maxBufferPx]="iconItemSize() * 100"
          [minBufferPx]="iconItemSize() * 50">
          @if (icons()?.length < 1) {
            <span class="input-icon-no-icons">{{ 'inputIcon.noIconForValue' | translate: { value: rawValue() } }}</span>
          } @else {
            <div
              *cdkVirtualFor="let icon of icons(); let index = index; trackBy: trackByFn.bind(this)"
              #item
              class="input-icon-list-item"
              highlighted
              [attr.data-highlighted]="highlightIndex() === index"
              [id]="icon.id"
              [style.height]="iconItemSize() + 'px'"
              [title]="icon.displayValue"
              (click)="select($event, icon)"
              (focus)="(undefined)"
              (mouseover)="updateLastItemHover(index)">
              <i aria-hidden="true" [class]="icon.id"></i>
              <span class="value">
                <span class="label iu-field-label">{{ icon.displayValue }}</span>
                <span class="id">{{ icon.id }}</span>
              </span>
            </div>
          }
        </cdk-virtual-scroll-viewport>
      </div>
    </iu-dropdown>
  </span>

  @if (hasConflict && dataStored) {
    <i
      #spanInput
      role="button"
      tabindex="0"
      [attr.title]="opConflict.iconTooltip"
      [attr.aria-label]="opConflict.iconTooltip"
      class="rtconflict fas fa-exclamation-triangle iconClass"
      (click)="showConflictPanel($event)"
      (keydown.enter)="showConflictPanel($event)"
      (keydown.space)="showConflictPanel($event)"></i>
  }

  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="rawValue()"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</div>

<ng-template #categoryItem let-category="category" let-isAll="isAll">
  <button
    #button
    class="input-icon-category"
    type="button"
    [attr.data-active]="(isAll && !selectedCategory()) || category === selectedCategory()"
    [attr.data-highlight]="highlightedCategoryEl() === button"
    (click)="selectCategory($event, !isAll ? category : undefined, input)">
    {{ category }}
  </button>
</ng-template>

<iu-field-conflict-panel #opConflict [field]="this" />
